import {useContext, useEffect, useState} from 'react'
import {NavLink, useNavigate} from 'react-router-dom'
import {AuthContext} from 'contexts/AuthContext'
import {useMutation} from 'react-query'
import {getWallet, logoutUser} from 'api'
import logo from 'assets/img/fero-logo-white.svg'
import logoMobile from 'assets/img/logo-white-mobile.svg'
import homeWhite from 'assets/img/home-white.svg'
import homeYellow from 'assets/img/home-yellow.svg'
import truckWhite from 'assets/img/truck-white.svg'
import truckYellow from 'assets/img/truck-yellow.svg'
import listWhite from 'assets/img/list-white.svg'
import listYellow from 'assets/img/list-yellow.svg'
import bellWhite from 'assets/img/bell-white.svg'
import bellYellow from 'assets/img/bell-yellow.svg'
import contactsWhite from 'assets/img/contacts-white.svg'
import contactsYellow from 'assets/img/contacts-yellow.svg'
import settingsWhite from 'assets/img/settings-white.svg'
import settingsYellow from 'assets/img/settings-yellow.svg'
import avatarPlaceholder from 'assets/img/avatar-placeholder.svg'
import walletIcon from 'assets/img/wallet-icon.svg'
import closeIcon from 'assets/img/close-icon.svg'
import logoutIcon from 'assets/img/logout.svg'
import phoneIcon from 'assets/img/phone.svg'
import {getItemFromStorage, removeItemFromStorage} from 'utils/storage'
import OutsideClickHandler from 'react-outside-click-handler/build/OutsideClickHandler'
import {mockNotifications} from 'utils/mockData'
import { notifyErrorOccured, notifySuccess } from 'utils/toastNotifications'
import {UserContext} from 'contexts/UserContext'
import {formatPrice} from 'utils/helpers'
import creditCardIcon from 'assets/img/credits.svg'

const Sidebar = ({
  setIsSidebarOpen,
  user,
  showNotifications,
  setShowNotifications,
}) => {
  const navigate = useNavigate()
  const { state, dispatch } = useContext(AuthContext)
  const {wallet, updateWallet} = useContext(UserContext)
  const userLoginData = getItemFromStorage({name: 'userLoginData'})
  const [walletData, setWalletData] = useState(null)

  const prepaidAmtLeft = state?.user?.data?.prepaidAmtLeft

  const {mutate: handleLogout} = useMutation('logoutUser', logoutUser, {
    onSuccess: () => {
      removeItemFromStorage({name: 'user'})
      removeItemFromStorage({name: 'userLoginData'})
      removeItemFromStorage({name: 'accessToken'})
      dispatch({})
      sessionStorage.clear()
      localStorage.clear()
      navigate('/login', {replace: true})
    },
  })

  const {mutate: handleGetWallet} = useMutation('getWallet', getWallet, {
    onSuccess: ({data}) => {
      setWalletData(data)
      updateWallet({walletData: data.walletData})
    },
  })
  const userId = user?._id

  useEffect(() => {
    if (!userId) return
    handleGetWallet({userId})
  }, [userId])

  const handleCopyPhoneNumber = async () => {
    try {
      await navigator.clipboard.writeText('866-982-2073')
      notifySuccess({ message: 'Phone number copied to clipboard' })
    } catch (err) {
      notifyErrorOccured({ message: 'Failed to copy phone number' })
    }
  }

  return (
    <nav className="z-50 flex flex-col bg-primary-blue w-full lg:w-auto lg:max-w-[220px] h-screen lg:min-h-screen font-open-sans text-white py-6 px-4">
      <div className="flex w-full justify-between">
        <img src={logo} alt="logo" className="hidden lg:block w-[144px]"></img>
        <img src={logoMobile} alt="logo" className="w-[94px] lg:hidden"></img>
        <img
          src={closeIcon}
          alt="close"
          className="lg:hidden cursor-pointer"
          onClick={() => setIsSidebarOpen(false)}
        ></img>
      </div>
      <ul
        className="mt-6 border-t border-[#386591] pt-4 gap-y-2.5 flex flex-col font-semibold whitespace-nowrap text-sm"
        onClick={() => setIsSidebarOpen(false)}
      >
        <li>
          <NavLink
            to="/dashboard"
            end
            className={({isActive}) =>
              `flex py-2 rounded px-3 gap-x-2.5 ${isActive && !showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`
            }
          >
            {({isActive}) => (
              <>
                <img
                  src={isActive && !showNotifications ? homeYellow : homeWhite}
                  alt="home"
                />
                <p>Home</p>
              </>
            )}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/create-order"
            end
            className={({isActive}) =>
              `flex py-2 rounded px-3 gap-x-2.5  ${isActive && !showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`
            }
          >
            {({isActive}) => (
              <>
                <img
                  src={
                    isActive && !showNotifications ? truckYellow : truckWhite
                  }
                  alt="create_order"
                />
                <p>Schedule a Hauler</p>
              </>
            )}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/order-history"
            end
            className={({isActive}) =>
              `flex py-2 rounded px-3 gap-x-2.5  ${isActive && !showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`
            }
          >
            {({isActive}) => (
              <>
                <img
                  src={isActive && !showNotifications ? listYellow : listWhite}
                  alt="list"
                />
                <p>Order History</p>
              </>
            )}
          </NavLink>
        </li>
        {/*<li>
          <OutsideClickHandler
            onOutsideClick={() => {
              if (showNotifications === true) setShowNotifications(false)
            }}
          >
            <div
              className={`cursor-pointer flex py-3 rounded px-3 gap-x-2.5  ${showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`}
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <img
                src={showNotifications ? bellYellow : bellWhite}
                alt="notifications"
              />
              <p>Notifications</p>
              {mockNotifications?.length > 0 && (
                <div className="flex items-center bg-[#E15252] text-white rounded px-2 py-0.5 text-xs font-bold">
                  {mockNotifications?.length}
                </div>
              )}
            </div>
          </OutsideClickHandler>
        </li>*/}
      </ul>
      <ul
        className="lg:mt-auto border-b border-[#386591] pt-2 lg:pt-2 gap-y-2.5 flex flex-col font-semibold whitespace-nowrap text-sm"
        onClick={() => setIsSidebarOpen(false)}
      >
        <li>
          <NavLink
            to="/dashboard/contacts"
            end
            className={({isActive}) =>
              `flex py-2 rounded px-3 gap-x-2.5 ${isActive && !showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`
            }
          >
            {({isActive}) => (
              <>
                <img
                  src={
                    isActive && !showNotifications
                      ? contactsYellow
                      : contactsWhite
                  }
                  alt="contacts"
                />
                <p>Contacts</p>
              </>
            )}
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/settings"
            end
            className={({isActive}) =>
              `flex py-2 rounded px-3 gap-x-2.5  ${isActive && !showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`
            }
          >
            {({isActive}) => (
              <>
                <img
                  src={
                    isActive && !showNotifications
                      ? settingsYellow
                      : settingsWhite
                  }
                  alt="settings"
                />
                <p>Settings</p>
              </>
            )}
          </NavLink>
        </li>
      </ul>
      <ul
        className="pt-2 gap-y-2.5 flex flex-col font-semibold whitespace-nowrap text-sm"
        onClick={() => setIsSidebarOpen(false)}
      >
        <li>
          <div className={`flex py-2 rounded px-3 gap-x-2.5 text-white`}>
            <div className="flex items-center justify-center blue-yellow-gradient relative gold-gradient !w-[34px] !h-[34px] rounded-full flex-shrink-0">
              {user?.profilePic &&
              user?.profilePic !==
                'https://devcdn.feronow.com/customer/0/0/avatar_placeholder_20250724.svg' ? (
                <img
                  src={user?.profilePic}
                  alt="avatar"
                  className="w-[34px] h-[34px] rounded-full object-cover flex-shrink-0 bg-white"
                />
              ) : (
                <img
                  src={avatarPlaceholder}
                  alt="avatar"
                  className="w-[18px] h-[18px] rounded-full object-cover flex-shrink-0"
                />
              )}
            </div>
            <div className="flex flex-col whitespace-normal">
              <p className="text-[#A0BED9] text-xs">WELCOME</p>
              <p className="font-bold">
                {user?.firstName + ' ' + user?.lastName}
              </p>
            </div>
          </div>
        </li>
        <li className="blue-gradient rounded-[12px]">
          <NavLink
            to="/dashboard/wallet"
            end
            className={({isActive}) =>
              `flex py-2 rounded-xl px-3 gap-x-2.5  ${isActive && !showNotifications ? 'text-[#FFDE30] bg-[#294663]' : 'text-white'}`
            }
          >
            <img src={walletIcon} alt="wallet" />
            <div className="flex flex-col">
              <p className="text-[#A0BED9] text-xs">MY BALANCE</p>
              <p>
                <span className="font-bold text-lg">
                  {wallet?.walletData
                    ? formatPrice(wallet?.walletData[0]?.balance)
                    : walletData?.walletData[0]?.balance}
                </span>{' '}
                <span className="text-[#A0BED9] text-xs">
                  {wallet?.walletData
                    ? wallet?.walletData[0]?.currency
                    : walletData?.walletData[0]?.currency}
                </span>
              </p>
            </div>
          </NavLink>
        </li>
        {prepaidAmtLeft > 0 && (
          <li>
            <div className="flex py-2 rounded px-3 gap-x-2.5 text-white">
              <img
                src={creditCardIcon}
                alt="card"
                className="w-5 h-5 brightness-0 invert"
              />
              <div className="flex flex-col flex-1">
                <p className="text-[#A0BED9] text-xs">PREPAID AVAILABLE</p>
                <div className="flex items-center gap-x-2">
                  <p className="font-bold text-md">
                    ${formatPrice(prepaidAmtLeft)}
                  </p>
                </div>
              </div>
            </div>
          </li>
        )}
        <li>
          <div className="flex py-2 rounded px-3 gap-x-2.5 text-white">
            <img
              src={phoneIcon}
              alt="phone"
              className="w-5 h-5 brightness-0 invert"
            />
            <div className="flex flex-col flex-1">
              <p className="text-[#A0BED9] text-xs">SUPPORT</p>
              <div className="flex items-center gap-x-2">
                <a href="tel:866-982-2073" className="font-bold hover:text-[#FFDE30] transition-colors">866-982-2073</a>
                <button
                  onClick={handleCopyPhoneNumber}
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                  aria-label="Copy phone number"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-white"
                  >
                    <path
                      d="M9.625 9.625H11.375C11.7202 9.625 12 9.34518 12 9V3.25C12 2.90482 11.7202 2.625 11.375 2.625H5.625C5.27982 2.625 5 2.90482 5 3.25V5"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 5H3.25C2.90482 5 2.625 5.27982 2.625 5.625V11.375C2.625 11.7202 2.90482 12 3.25 12H8.375C8.72018 12 9 11.7202 9 11.375V5Z"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div
        className="pt-3 rounded px-3 gap-x-2.5 mt-3 border-t border-[#386591] gap-y-2.5 flex font-semibold whitespace-nowrap text-sm cursor-pointer"
        onClick={() =>
          handleLogout({
            ipAddress: userLoginData?.logData?.ipAddress,
            latitude: userLoginData?.logData?.latitude,
            longitude: userLoginData?.logData?.longitude,
            deviceMake: userLoginData?.logData?.Make, // deviceMake ?
            //deviceTime:
            deviceModel: userLoginData?.logData?.deviceModel,
            deviceOsVersion: userLoginData?.logData?.OSVersion,
            city: userLoginData?.logData?.City,
            country: userLoginData?.logData?.Country,
            deviceId: userLoginData?.logData?.deviceId,
          })
        }
      >
        <img src={logoutIcon} alt="logout" />
        <p>Logout</p>
      </div>
    </nav>
  )
}

export default Sidebar
